import React from 'react';
import EditarEquipos from '../../../components/insumos/equipos/EditarEquipos';

const EquiposEditarPage: React.FC = () => { 
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <h1>Editar Equipos</h1>
      <br />
      <br />
      <EditarEquipos />
    </div>
  );
};

export default EquiposEditarPage;